module.exports = __webpack_public_path__ + "static/media/repair_img.5ca10e0a.png";